/** Classe das linhas de coluna principal; é o alvo do tooltip "colunas mínimas". */
export const MIN_COLUMNS_TARGET_CLASS = "ds-table-settings-locked-column";
